import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React from 'react';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { RequestEntity, ICategoryPositionItem } from 'types';
import { categoryTypes } from 'appConstants';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: ICategoryPositionItem;
	positionNumber: number;
	dragHandleProps: DraggableProvidedDragHandleProps | undefined;
}

const Item: React.FC<IItem> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const categoryRowClasses = classNames(style.category, style.row);
	const imgWrapperClass = classNames(style.imgWrapper);
	const categoryNameClasses = classNames(style.categoryName);
	const categoryTypeRowClasses = classNames(style.categoryType, style.row);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row);

	const categoryTypeName = categoryTypes.find((el) => el.categoryID === data.categoryType)?.categoryName || null;

	const restaurants = data.restaurants.map((el) => ({
		...el,
		restaurantName: el.name,
	}));

	return (
		<div className={containerClasses}>
			<div className={categoryRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<div className={imgWrapperClass}>
					<ImgUploaderByEntityId
						resource={RequestEntity.Categories}
						entityID={data.filePath ? data.id : ''}
						photoSize="Small"
						loaderSize="small"
					/>
				</div>
				<Text className={categoryNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<Text
				className={categoryTypeRowClasses}
				translationNameSpace="form"
				translationKey={categoryTypeName}
				withTooltip={true}
			/>
			<div className={restaurantRowClasses}>
				<RestaurantsList restaurants={restaurants} />
			</div>
			<Text className={customerRowClasses} translationKey={data.customer.name} withTooltip={true} />
		</div>
	);
};

export default Item;
